import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { classNames } from "../../utils";

export default function Badge({ active }) {
  const [controlBadge, setControlBadge] = useState(true);
  useEffect(() => {
    const timer = active ? setInterval(() => {
      setControlBadge(prev => !prev);
    }, 1000) : null
    return () => {
      if (timer) clearInterval(timer);
    };
  }, []);
  return <div className={classNames("badge", { active }, { badge__pulse: active && controlBadge })}>
  </div >;
}

Badge.propTypes = {
  active: PropTypes.bool,
};
